import React from 'react';
import HomeContent from '../components/HomeContent';
import { StudentsProvider } from '../contexts/StudentsContext';

const Home = () => {
  return (
    <StudentsProvider>
      <HomeContent />
    </StudentsProvider>
  );
};

export default Home;
